import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=f8a677f4&scoped=true&"
import script from "./Gate.vue?vue&type=script&lang=js&"
export * from "./Gate.vue?vue&type=script&lang=js&"
import style0 from "./Gate.vue?vue&type=style&index=0&id=f8a677f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a677f4",
  null
  
)

export default component.exports